var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import Inset from 'syf-component-library/ui/spacing/Inset';
import query from 'syf-component-library/const/mediaQueries';
import { colors, fontSizes } from 'syf-component-library/defaultTheme';
import { Textfield } from 'syf-component-library/ui/atoms';
import { Label } from 'syf-component-library/ui/atoms/Textfield/subcomponents';
import { FAR_CIRCLE_EXCLAMATION } from '../../../../const/icon-props';
import Icon from '../../../icon';
export var TextWrapper = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  font-size: ", "px;\n"], ["\n  display: inline-block;\n  font-size: ", "px;\n"])), fontSizes.root);
export var CustomTextField = styled(Textfield)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", " {\n    color: ", ";\n    @media ", " {\n      display: inline-block;\n      width: 90%;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      overflow: hidden;\n    }\n  }\n"], ["\n  ", " {\n    color: ", ";\n    @media ", " {\n      display: inline-block;\n      width: 90%;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      overflow: hidden;\n    }\n  }\n"])), Label, function (_a) {
    var theme = _a.theme, error = _a.error;
    return error === '' ? theme.bodyText : colors.error;
}, query.lessThanSmall);
var ErrorWrapper = styled(Inset)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  margin-top: 1px;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  margin-top: 1px;\n"])));
export var ErrorIcon = function () { return (_jsx(ErrorWrapper, __assign({ right: "xsmall" }, { children: _jsx(Icon, { title: "circle error icon", color: colors.error, icon: FAR_CIRCLE_EXCLAMATION, size: "1x" }) }))); };
var templateObject_1, templateObject_2, templateObject_3;
